import './index.scss';
import React from 'react';
import { IPermissionContentProps } from '../../interface';
import { lang } from '@umu/ukit-lang';

const EmptyPermissionInfo = (_props: IPermissionContentProps) => {
    return <div className="course-permission-info">{lang('尚未关联内容')}</div>;
};
export { EmptyPermissionInfo };
